import { useMemo as o } from "react";
import { toast as r } from "@systemeio/ui";
import { createHttpClient as s, getUseBaseFetch as n, getErrorMapper as c } from "@systemeio/util";
const t = s();
t.interceptors.response.use((e) => e, c(t));
const p = () => o(
  () => ({
    push: async (e) => (window.location.assign(e), !0),
    replace: async (e) => (window.location.replace(e), !0)
  }),
  []
), u = n({
  httpClient: t,
  useRouter: p,
  toast: r
}), l = (e) => u(e);
export {
  t as httpClient,
  l as useFetch
};
